import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// TODO: Reemplaza esto con la configuración de TU proyecto de Firebase
const firebaseConfig = {
   apiKey: "AIzaSyCXflSeQJZ1vbnxflsZvzl1k3SagXMscMs",
  authDomain: "web-caes.firebaseapp.com",
  projectId: "web-caes",
  storageBucket: "web-caes.firebasestorage.app",
  messagingSenderId: "953476032598",
  appId: "1:953476032598:web:cbd9a9a43f72c8971033f7",
  measurementId: "G-GB6H644LZQ"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Exporta la instancia de Firestore para usarla en otros archivos
// ¡Esta es la línea que soluciona el error principal!
export const db = getFirestore(app);
export const auth = getAuth(app); 